import * as yup from 'yup'

const emptyStringToNull = (value, originalValue) =>
  String(originalValue).trim() === '' ? null : value

export const schemaContractConfig = yup.object().shape({
  dayExpiration: yup
    .number()
    .typeError('Preencha este campo')
    .moreThan(0, 'Digite um número maior ou igual a 1')
    .lessThan(32, 'Digite um número menor ou igual a 31')
    .required(),
  urlNotification: yup.string().url(),
  settings: yup.object().shape({
    daysToOverdueInvoice: yup
      .number()
      .typeError('Preencha este campo')
      .min(0)
      .required(),
    generateServiceTaxInvoices: yup.boolean().required(),
    invoiceInterval: yup
      .number()
      .typeError('Preencha este campo')
      .min(0)
      .max(15)
      .transform(emptyStringToNull)
      .nullable(),
    daysToGenerateNfe: yup
      .number()
      .typeError('Preencha este campo')
      .min(0)
      .transform(emptyStringToNull)
      .nullable(),
  }),
})

export default schemaContractConfig
